import React, {useEffect, useCallback, useRef,useState} from 'react';
import PropTypes from 'prop-types';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl'
import Form from 'react-bootstrap/Form'
export const RScanInput = ({name, label, placeHolder,type, info, handleChange, disabled, nullable}) => {

		const [value, setValue] = useState("");
		const error = useRef([]);
		const inputRef =  useRef(null);

		const handleInputChange = useCallback((event) => {
				event.target.value = event.target.value.trim().toUpperCase();

				if(nullable === undefined || nullable === false){
					if(event.target.value.length < 1){
						event.error =  {name: name, message :["Please fill it"]};
					}
					else
						event.error = {name: name, message :[]};
				}
				else
					event.error = {name: name, message :[]};

				if (new RegExp(/^\/|\\|\.|:|\*|\?|"|<|>|\|$/).exec(event.target.value) !== null ) {
					event.error =   {name: name, message :["a valid ID can't contains / \\ . : * ? \" < > "]};
				}

				error.current = event.error.message;
				handleChange(event);
				setValue("");
		},[name, handleChange,nullable]);

		useEffect(()=>{
			var event = new Event('input', { bubbles: true});
			inputRef.current.dispatchEvent(event);
			handleInputChange(event);
		}, [handleInputChange])

		useEffect(()=>{
			error.current = [];
		}, [])

		return (
			<>
      <InputGroup className="mb-3">
        <InputGroup.Prepend>
          <InputGroup.Text className="bg-custom-green r-prepend">{label} </InputGroup.Text>
        </InputGroup.Prepend>
        <FormControl
					autoFocus
					ref = {inputRef}
					name={name}
					value={value}
					className={"form-control r-form-control" + (error.current.length > 0 && value !== '' ? 'is-invalid' : value !== ''? 'is-valid' : '')}
					aria-label="Small"
					aria-describedby="inputGroup-sizing-sm"
					placeholder={placeHolder}
					onKeyPress={event => {
              if (event.key === "Enter") {
                handleInputChange(event);
              }
					}}
					onBlur={()=>{inputRef.current.focus()}}
					onChange = {(event)=>{setValue(event.target.value)}}
					disabled={disabled}
					isValid={error.current.length === 0 && ((value !== ""  && !nullable) || nullable)}
					isInvalid={error.current.length > 0}
					required={true} />
				<FormControl.Feedback type="invalid">
					{error.current.map(function(er,index){return (<p key={"er_"+index}>{er}</p>)})}
				</FormControl.Feedback>
				<InputGroup>
					<Form.Text className="text-muted">
						{info !== null && info !== ""
							?
								info
							:
								false
						}
					</Form.Text>
        </InputGroup>
      </InputGroup>
			</>
		);

}
RScanInput.propTypes = {
	name: PropTypes.string,
	label: PropTypes.object,
	placeHolder: PropTypes.string,
	info: PropTypes.string,
	type: PropTypes.string,
	handleChange: PropTypes.func,
	disabled:PropTypes.bool,
	nullable:PropTypes.bool,
};
